const PORTFOLIO_SET_GROUPS = "PORTFOLIO_SET_GROUPS"
const PORTFOLIO_SET_STUDENTS = "PORTFOLIO_SET_STUDENTS"
const PORTFOLIO_SET_FILES = "PORTFOLIO_SET_FILES"

const portfolioTypes = {
    PORTFOLIO_SET_GROUPS,
    PORTFOLIO_SET_STUDENTS,
    PORTFOLIO_SET_FILES,
}

export default portfolioTypes